import { useEffect, useState } from "react";

export const useLocalStorageFlag = (key: string, defaultVal = false) => {
  const [flag, setFlag] = useState<boolean>(() => {
    try {
      return localStorage.getItem(key) === "1";
    } catch {
      return defaultVal;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, flag ? "1" : "0");
    } catch {}
  }, [key, flag]);

  return { flag, setFlag };
};
